// Dependencies
import Map from 'modules/map';


class PageContact {
  /**
   * Constructor: Contact Page Constructor.
   */
  constructor() {
    // Root
    this._root = document.querySelector('[layout="page-contact"]');
    
    // Elements
    this._form   = this._root.querySelector('.wpcf7');
    this._map    = this._root.querySelector('#google-map');
    this._inputs = [...this._root.querySelectorAll('input[type="text"], input[type="email"], textarea')];
    this._file   = [...this._root.querySelectorAll('input[type="file"]')];
    
    // Dependencies
    if (this._map) {
      this.Map = new Map({
        root   : this._map,
        options: {
          center: {
            lat: parseFloat(this._map.getAttribute('data-lat')),
            lng: parseFloat(this._map.getAttribute('data-lng')),
          },
          zoom: 15,
          disableDefaultUI: true,
        },
      });
    }

    // Events
    this._onFocus   = this.focus.bind(this);
    this._onBlur    = this.blur.bind(this);
    this._onUpload  = this.upload.bind(this);
    this._onSuccess = this.reset.bind(this);

    this._form.addEventListener('wpcf7mailsent', this._onSuccess);

    this._inputs.map((input) => {
      input.addEventListener('focus', this._onFocus);
      input.addEventListener('blur', this._onBlur);
    });

    this._file.map((file) => {
      file.addEventListener('change', this._onUpload);
    });
  }


  /**
   * Focus: Manage inputs focus.
   * 
   * @param {Object} e - Event
   */
  focus(e) {
    const el       = e.target;
    const ancestor = el.parentNode;
    const field    = ancestor.parentNode;

    field.classList.add('is-focus');
  }


  /**
   * Blur: Manage inputs blur.
   * 
   * @param {Object} e - Event
   */
  blur(e) {
    const el       = e.target;
    const value    = el.value;
    const ancestor = el.parentNode;
    const field    = ancestor.parentNode;
    
    field.classList.remove('is-focus');
    field.classList.remove('is-filled');

    if (value.length !== 0) {
      field.classList.add('is-filled');
    }
  }


  /**
   * Upload: Manage file uploads.
   * 
   * @param {Object} e - Event
   */
  upload(e) {
    const el       = e.target;
    const files    = el.files;
    const ancestor = el.parentNode;
    const field    = ancestor.parentNode;
    const label    = field.querySelector('label .text');
    const text     = label.getAttribute('data-text');

    if (!text) {
      label.setAttribute('data-text', label.innerHTML);
    }

    if (files.length !== 0) {
      label.innerHTML = files[0].name;
    }
    else {
      if (text) {
        label.innerHTML = text;
      }
    }
  }


  /**
   * Reset: Reset inputs and files.
   */
  reset() {
    // Reset Inputs
    this._inputs.map((input) => {
      const ancestor = input.parentNode;
      const field    = ancestor.parentNode;

      field.classList.remove('is-focus');
      field.classList.remove('is-filled');
    });

    // Reset File Label
    this._file.map((file) => {
      const ancestor = file.parentNode;
      const field    = ancestor.parentNode;
      const label    = field.querySelector('label .text');
      const text     = label.getAttribute('data-text');

      if (text) {
        label.innerHTML = text;
      }
    });
  }
}

export default PageContact;


// WEBPACK FOOTER //
// ./src/js/templates/page-contact.js